var isObject = require('../internals/is-object');
var anObject = require('../internals/an-object');

module.exports = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) {
    throw TypeError("Can't set " + String(proto) + ' as a prototype');
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/validate-set-prototype-of-arguments.js
// module id = 605
// module chunks = 0